module.exports = __webpack_public_path__ + "img/svg/selected-box-overlay-mobile.d724bf24680690e8bcd0ac6f816ac23e.svg";